import { z } from 'zod';

import { CompanyId, PoolId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const UpsertPoolSideEffectContext = BaseLoanIdSideEffect.extend({
  poolId: PoolId,
  companyId: CompanyId,
});
export const UpsertPoolSideEffect = UpsertPoolSideEffectContext.extend({
  type: z.literal('upsertPool'),
});
export type UpsertPoolSideEffect = z.infer<typeof UpsertPoolSideEffect>;
